<div class="marquee" *ngIf="!isProduction">
  <div class="marquee-text" *ngFor="let i of [1,2,3,4,5,6,7,8]">
    <span class="text-primary-100/50">DEMO</span>
  </div>
</div>
<div class="bg-gray-50 min-h-screen flex items-center justify-center">
  <div class="bg-white w-3/4 md:w-1/3 rounded-xl md:py-7 p-5 md:px-10 flex flex-col items-center justify-center relative">
    <div class="-top-4 -left-6 absolute">
      <button [routerLink]="['','home']" class="bg-gray-100 p-0.5 text-gray rounded-xl">
        <div class="py-1.5 pl-2.5 pr-3 bg-white hover:bg-gray-100/50 rounded-xl flex items-center gap-1.5">
          <mat-icon svgIcon="home"></mat-icon>
          {{ 'Home' | concat | translate }}
        </div>
      </button>
    </div>
    <img src="assets/images/emblem.png" class="w-16 md:w-20" alt="">
    <span class="text-black text-xl font-bold mt-5 mb-2">{{ 'Log In' | concat | translate }}</span>
    <p class="text-gray-dark">{{ 'Login Welcome Note' | concat | translate }}</p>
    <div class="w-full mt-3">
      <form
        (ngSubmit)="login(form.value)"
        [formGroup]="form"
        autocomplete="off"
        novalidate
      >
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Email Address' | concat | translate }}</mat-label>
          <input type="email" matInput formControlName="username">
          <mat-icon matIconSuffix>email</mat-icon>
          <mat-error>
          <span
            *ngIf="!form.get('username')?.valid && form.get('username')?.touched">
              {{ 'Field is required' | concat | translate }}
          </span>
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'Password' | concat | translate }}</mat-label>
          <input [type]="hide ? 'password' : 'text'" matInput formControlName="password">
          <button type="button" mat-icon-button matSuffix (click)="hide = !hide"
                  [attr.aria-label]="'Hide'"
                  [attr.aria-pressed]="hide">
            <mat-icon class="material-icons-outlined">{{ hide ? 'visibility_off' : 'visibility' }}
            </mat-icon>
          </button>
          <mat-error>
          <span
            *ngIf="!form.get('password')?.valid && form.get('password')?.touched">
              {{ 'Field is required' | concat | translate }}
          </span>
          </mat-error>
        </mat-form-field>

        <div class="w-full mb-3">
          <button [disabled]="!form.valid || loading" class="w-full" mat-raised-button color="primary">
            {{ 'Login' | concat | translate }}
          </button>
      </div>
      </form>
      <div class="w-full mt-4 text-center">
        <p class="text-sm md:text-md text-gray-dark">{{ 'Forgot Your Password' | concat | translate }}?
          <a
            routerLink="/forgot-password" class="text-primary font-bold">
            {{ 'Reset'  | concat | translate }}
          </a>
        </p>
      </div>
    </div>
  </div>
</div>
